import * as React from "react";
import interact from 'interactjs'

import $ from "jquery";
import PageContext from "../../Context/PageContext";
import ContentEditable from 'react-contenteditable'

import { HandleClasses, HandleStyles, Rnd } from "react-rnd";

import { useContext } from "react";

import { Chart as ChartJS, registerables } from "chart.js";
import { Line } from "react-chartjs-2";

import { ReactSVG } from 'react-svg'

import { isMobile } from 'react-device-detect';
import { deleteItemUtil, handleCloneAndCornerPosition } from "../../Util/ElemUtil";
import { createAddCropCadreElementAction, createMoveElementAction, createSizeElementAction } from "../../history/element.history";


ChartJS.register(...registerables);

export default function TextElement(props: any) {

    const { objItems, selectedItem, setSelectedItem, selectedItemIsLock,
        setSelectedItemIsLock, zoomValue, setIsOpenOpacity, setOpenAbsoluteMenuSection, chartRef, setChartRef, elevationData, removeItem, setCropCadreImage, cropCadreImage, cropImage, setCropImage,
        history, addItem } = useContext(PageContext);

    const [rnd, setRnd] = React.useState<Rnd | null>(null);
    const rndRef = React.useRef<Rnd | null>(null);
    const [zoom, setZoom] = React.useState(1);
    const [editText, setEditText] = React.useState(false);
    const [isSelectedItem, setIsSelectedItem] = React.useState(false);
    const [positionT, setPositionT] = React.useState(() => {
        //return { x: 0, y: 0 }
        return { x: props.val.x, y: props.val.y }
    });

    const [onOverlap, setOnOverlap] = React.useState<any>(() => {
        return {
            id: null, element: null,
            back: { src: null, width: null, height: null, transform: null },
            new: { src: null, text: null, sizePX: { width: null, height: null }, sizePourcent: { width: null, height: null } }
        }
    });

    const chartRefState = React.useRef<ChartJS<"line">>();

    const val = props.val;
    const index = props.index;

    //Utiliser pour définir la taille des corner resize
    //valeur du corner invisible (plus grand que celui visible pour faciliter l'action)
    var sizeCornerResizeSize = isMobile ? 20 / zoomValue : 15 / zoomValue;
    var sizeCornerResizeAbsolute = sizeCornerResizeSize / 2;
    const epaisseurBordure = 6;
    const epaisseurBordureTopBottom = epaisseurBordure / 2;
    const maxWidthORHeightCorner = isMobile ? 150 : 100;

    //par rapport à la taille de corner-resize dans fichier CSS
    //const sizeCornerResizeSizeVisible = isMobile ? 60 / 2 : 26 / 2;

    React.useEffect(() => {
        val.rnd = rndRef;

        //console.log(objItems)

        //workaround => quand on resize la fenetre navigateur, ou le 1er scroll sur mobile la taille se resize
        //a ce moment, comme la canvas profil elevation est responsive (pour fonctionner sur elem onresize), il perd sa configuration taille
        window.addEventListener('resize', function () {
            if (val.type == "elevation-element") {

                var elemW = val.width;
                var elemH = val.height;

                if (typeof elemW === 'string' && elemW.includes("px")) elemW = parseInt(elemW.replace("px", ""))
                if (typeof elemH === 'string' && elemH.includes("px")) elemH = parseInt(elemH.replace("px", ""))

                //on met un timout sinon les events qui je ne sais pas pourquoi retaille la carte sont appelées après sur mobile
                setTimeout(() => {
                    chartRefState.current?.resize(elemW, elemH);
                }, 1);
            }

        });

    }, [])

    React.useEffect(() => {

        //console.log(objItems)

    }, [objItems])

    React.useEffect(() => {
        if (setChartRef) {
            setChartRef(chartRefState);
        }

    }, [elevationData])

    //on gère un état pour savoir si l'élement est sélectionné
    React.useEffect(() => {
        if (selectedItem != null && val.id == selectedItem.id) {
            setIsSelectedItem(true)
        } else {
            setIsSelectedItem(false)
        }

    }, [selectedItem])


    React.useEffect(() => {
        //on passe par le callback de isSelectedItem, car l'objet devient dragable quand setIsSelectedItem est appellé
        //On remplace le contenu de clone_div (en 1er plan) par le span qui contient les corner resize
        //attention au mode texte on fait pas ?

        //"mapbox-id" == selectedItem.id
        if (isSelectedItem) {

            let cloneDiv = $("#clone-" + selectedItem!.id);

            let item = objItems.find(item => item.id === selectedItem!.id);

            let spanClone = $('#' + selectedItem.id)!.find("span");

            //move spanClone into an above div (1er plan)
            if (cloneDiv != null && spanClone != null) cloneDiv.append(spanClone)
            //update clone div position and size
            if (item.type != "text-element") {

                var elemW = item.width;
                var elemH = item.height;

                //pour les images par exemples, on set seulement width pour garder le ratio, donc il faut aller chercher la hauteur
                if (isNaN(elemW)) elemW = $('#' + item.id).width();
                if (isNaN(elemH)) elemH = $('#' + item.id).height();

                cloneDiv.css({ top: item.y, left: item.x, width: elemW, height: elemH, position: 'absolute' });

                if (item.width < maxWidthORHeightCorner || item.height < maxWidthORHeightCorner)
                    cloneDiv.find(".corner-resize-c").hide()

            }
            else if (item.type == "text-element") {

                let article = $('#' + selectedItem.id)!.find("article");

                var newEle = '<span class="text-eleme-active"><div class="" style="position: absolute; user-select: none; width: 100%; height: ' + epaisseurBordure + 'px; top: -' + epaisseurBordureTopBottom + 'px; left: 0px; background-color: rgb(139, 61, 255); z-index: 999;"></div>' +
                    '<div class="" style="position: absolute; user-select: none; width: ' + epaisseurBordure + 'px; height: 100%; top: 0px; right: -' + epaisseurBordureTopBottom + 'px; background-color: rgb(139, 61, 255); z-index: 999;"></div>' +
                    '<div class="" style="position: absolute; user-select: none; width: 100%; height: ' + epaisseurBordure + 'px; bottom: -' + epaisseurBordureTopBottom + 'px; left: 0px; background-color: rgb(139, 61, 255); z-index: 999;"></div>' +
                    '<div class="" style="position: absolute; user-select: none; width: ' + epaisseurBordure + 'px; height: 100%; top: 0px; left: -' + epaisseurBordureTopBottom + 'px; background-color: rgb(139, 61, 255); z-index: 999;"></div>' +
                    '</span>'

                cloneDiv.html(newEle)

                handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, article.width(), article.height(), true, zoomValue);

            }



            //event listener for pen
            //on utilise jquery listener pour éviter trop de config context (en gros pour aller plus vite)
            if (val.type == "text-element") {
                $("#stylo-" + val.id).on("click", function (event) {
                    //on passe par un workaround pour faire passer la données (attribut datat)
                    setEditText(event.target.dataset.is == "true" ? false : true);
                });
            }

        }
    }, [isSelectedItem]);

    /*React.useEffect(() => {
        console.log(selectedItemIsLock)
        if (isSelectedItem) {
            let item = objItems.find(item => item.id === selectedItem!.id);
            if (item.type == "text-element" && selectedItemIsLock) {
                //dans le cas ou on a cliquer sur l'element texte, et qu'on le lock, on enlève l'active, et le orange s'y mettra
                $('.text-eleme-active').remove();
            }
        }

    }, [selectedItemIsLock])*/

    /* set selectedItem, check if it is lock, set css selected element to selected element, remove from other obj css*/
    function selectElement(event: React.MouseEvent<HTMLElement>) {

        var element = event.currentTarget.querySelector('div');
        //var element = event.currentTarget;

        //si on click sur le meme element déjà selectionner on fait rien
        if (setSelectedItem != null && element != null && selectedItem != null && element.id == selectedItem.id) {
            //on fait rien pour garantir que contenteditable fonctionne

        }
        else if (setSelectedItem != null) {
            setSelectedItem(element);
            //lorsqu'on reclick sur un element on disable l'edition
            setEditText(false);
            //Cas spécial pour l'élément texte, on supprime les bordures active
            $('.text-eleme-active').remove();
        }

        if (element != null) {

            //close collapse opacity
            if (setIsOpenOpacity != null) setIsOpenOpacity(false);
            //close position section
            if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection('')

            const item = objItems.find(item => item.id === element?.id);
            /* test if this object is lock */
            if (setSelectedItemIsLock != null) { setSelectedItemIsLock(item.isLock); }
        }

        //si on clique sur un autre élément et que le cropCadreImage est ouvert sur un autre objet
        //on compare avec cropCadreImage.orignalId car c'est lui qui est sélectionné
        if (cropCadreImage != null && setSelectedItem != null && element != null && element.id != cropCadreImage.originalId) {
            //close (delete) cropCadre card and show img
            if (cropCadreImage != null) $("#img-" + cropCadreImage.originalId).css('visibility', 'visible');
            if (setCropCadreImage != null) setCropCadreImage(null)
        }

        //si on clique sur un nouvel élément et que cropImage est ouvert sur un objet
        //on ferme le cropImage
        if (cropImage != null && setSelectedItem != null && element != null && element.id != cropImage.id) {
            //avec cropImage on créer une copie de l'élément image, si on le ferme, on remet l'image initiale et son clone container que l'on masqué
            $("#" + cropImage.id).css('visibility', 'visible');
            $("#clone-container-" + cropImage.id).css('display', 'block');
            if (setCropImage != null) setCropImage(null)
        }

    }

    function updatePositionElement(e: any, position: any) {
        const item = objItems.find(item => item.id === position.node.id);

        handleCloneAndCornerPosition(item, position, position.node.offsetWidth, position.node.offsetHeight, true, zoomValue);

        //handle history
        var backPosition = { x: item.x, y: item.y, width: position.node.offsetWidth, height: position.node.offsetHeight, zoomValue, crop: cloneCrop(item.crop) }
        var backPositionForCadre = { x: item.x, y: item.y, width: position.node.offsetWidth, height: position.node.offsetHeight, zoomValue }

        if (navigator.userAgent.indexOf("Firefox") !== -1) {
            item.x = position.x; item.y = position.y;
        } else {
            item.x = position.x; item.y = position.y;
        }

        //CropImageCard update position
        if (item.type == 'image-element') {
            //on met à jour les positions initales du crop à travers la position de fullImage (qui est notre repère)
            if (item.crop && item.crop.isCrop) {
                item.crop.fullImage.x = position.x - getIntSize(val.crop.cropPart.x);
                item.crop.fullImage.y = position.y - getIntSize(val.crop.cropPart.y);
            }
        }


        //on veut combiner l'état d'intersection et le relachement de la souri, càd le fin de drag
        //pour le test, on va considérer que overlap tjr dedans, mais il faut ajouter check still intersection
        if (onOverlap.id != null) {

            var itemCropCadre = onOverlap.element;
            var initCropCadre = cloneCropCadre(itemCropCadre.cropCadre);
            var initSrc = itemCropCadre.src; var initText = itemCropCadre.text;
            //change saved item src, change DOM too
            itemCropCadre.src = onOverlap.new.src;
            //on récupère l'info si l'image est upload ou non
            itemCropCadre.text = onOverlap.new.text;

            //dans le cas où on ajoute une nouvelle image dans un cadre élément qui contenait déjà une nouvelle image
            //on réinitialise les valeurs de cropCadre
            if (itemCropCadre.cropCadre.isPushImg) {
                itemCropCadre.cropCadre = {
                    sizePX: onOverlap.new.sizePX != null ? onOverlap.new.sizePX : { width: null, height: null },
                    sizePourcent: onOverlap.new.sizePourcent != null ? onOverlap.new.sizePourcent : { width: null, height: null },
                    transform: "translate(0px, 0px)",
                    translate: { x: 0, y: 0 },
                }
            }
            else {
                itemCropCadre.cropCadre.sizePX = onOverlap.new.sizePX;
                itemCropCadre.cropCadre.sizePourcent = onOverlap.new.sizePourcent;
            }

            itemCropCadre.cropCadre.isPushImg = true;

            deleteItemUtil(null, { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection });

            //history for crop cadre
            var actionCrop = createAddCropCadreElementAction(
                itemCropCadre,
                item,
                { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem },
                { ...backPositionForCadre, cropCadre: initCropCadre, initSrc: initSrc, initText: initText },
                { x: position.x, y: position.y, width: position.node.offsetWidth, height: position.node.offsetHeight, zoomValue: zoomValue, cropCadre: cloneCropCadre(itemCropCadre.cropCadre), initSrc: itemCropCadre.src, initText: itemCropCadre.text }
            );

            history.add(actionCrop);

        }


        //handle history => no transfrom niether crop cadre, juste move element
        if (onOverlap.id == null) {

            var action = createMoveElementAction(
                item,
                backPosition,
                { x: position.x, y: position.y, width: position.node.offsetWidth, height: position.node.offsetHeight, zoomValue, crop: cloneCrop(item.crop) }
            );

            history.add(action);
        }


        setZoom(1)
    }

    function getIntSize(size: any) {
        if (typeof size === 'string' && size.includes("px"))
            return parseInt(size.replace("px", ""))
        else return size
    }

    //from https://codesandbox.io/p/sandbox/react-rnd-collision-example-4impqy?file=%2Fsrc%2Findex.js%3A32%2C7-32%2C42
    //reduire le boudingbox pour prendre que la moitié !! ça sera plus fluidre
    function haveIntersection(other: any, main: any) {
        return !(
            main.x > other.x + other.width ||
            main.x + main.width < other.x ||
            main.y > other.y + other.height ||
            main.y + main.height < other.y
        );
    }

    function isMouseInside(target: any, mouse: any) {
        return (
            mouse.x >= target.x &&
            mouse.x <= target.x + target.width &&
            mouse.y >= target.y &&
            mouse.y <= target.y + target.height
        );
    }

    function handleOverlap(item: any, xy: any) {
        var main = document.querySelector("#" + item.id); // current dragged or resized node
        var targetRect = main?.getBoundingClientRect();

        //il faudra que target soit la position de la souri

        objItems.forEach((element) => {
            if (element.type == 'cadre-element') {
                //si on est dans une autre intersection en cours, on peut pas entrer dans une nouvelle ! && onOverlap.id != null 
                //if (haveIntersection(document.querySelector("#" + element.id)?.getBoundingClientRect(), targetRect) && onOverlap.id == null) {
                if (isMouseInside(document.querySelector("#" + element.id)?.getBoundingClientRect(), xy) && onOverlap.id == null) {

                    var sourceImage = item.src;

                    //ici on récupère la taille de l'image pour initialiser les valeurs de crop
                    //car quand c'est carré, c'est facile, mais si ratio != 1:1, il faut calculer les tailles

                    var imgWidth = getIntSize(item.width);
                    var imgHeight = getIntSize(item.height);
                    //on prend le minum, qui servira de référence 100%

                    var h = null; var w = null; var hPourcent = null; var otherPourcent = null; var sizePX = null; var sizePourcent = null;
                    var ratio = null;
                    //si taille égale, on peut laisser gérer avec 100% et la taille de élément par défaut
                    //la taille plus petite est celle qu'on adapte à element
                    //la partie ratio gère le cas de cadre-element pas 1:1
                    if (imgWidth < imgHeight) {
                        w = getIntSize(element.width);
                        h = imgHeight / imgWidth * w;
                        //multiplier par le ratio de hateur de l'image car pas forcément carré
                        ratio = getIntSize(element.width) / getIntSize(element.height);
                        otherPourcent = (imgHeight / imgWidth * 100 * ratio).toFixed(3) + '%'
                        sizePX = { width: w, height: h }
                        sizePourcent = { width: "100%", height: otherPourcent }
                    }
                    //la partie ratio gère le cas de cadre-element pas 1:1
                    else if (imgWidth > imgHeight) {
                        h = getIntSize(element.height);
                        w = imgWidth / imgHeight * h;
                        //multiplier par le ratio de longueur de l'image car pas forcément carré
                        ratio = getIntSize(element.height) / getIntSize(element.width);
                        otherPourcent = (imgWidth / imgHeight * 100 * ratio).toFixed(3) + '%';

                        sizePX = { width: w, height: h }
                        sizePourcent = { width: otherPourcent, height: "100%" }
                    }
                    //si l'image est carré 1:1, on recalcul si finalement element dans lequel on insert est pas carré
                    else {

                        w = getIntSize(element.width);
                        h = getIntSize(element.height);

                        var maxWH = Math.max(w, h);

                        //w same height
                        sizePX = { width: maxWH, height: maxWH }
                        //on gère le cas de la taille de élément
                        //si 1:1 on laisse
                        //si 1:2 hauteur:largeur, alors on set w à 100% et h pourcentage du ratio w/h
                        //si 2:1, alors on set h à 100% et w à pourcentage du ratio h/W
                        if (h < w) sizePourcent = { width: "100%", height: w / h * 100 + "%" }
                        else if (h > w) sizePourcent = { width: h / w * 100 + "%", height: "100%" }
                        //else sizePourcent = { width: null, height: null }
                        //on met 100%
                        else sizePourcent = { width: "100%", height: "100%" }
                    }


                    //on stocke les anciennes valeurs de crop-cadre
                    //on stock un state du style onOverlap
                    //pour eviter de rechecker tout et tout
                    if (onOverlap.id != element.id && sizePX != null) {

                        //si on a pas l'image par défaut et qu'il y a eu une image push, alors pour la taille, il faut aller chercher les infos dans cropCadre
                        var tempWidth = element.cropCadre != null && element.cropCadre.isPushImg ? element.cropCadre.sizePourcent.width : element.width;
                        var tempHeight = element.cropCadre != null && element.cropCadre.isPushImg ? element.cropCadre.sizePourcent.height : element.height;
                        var tempTransform = element.cropCadre != null && element.cropCadre.isPushImg ? element.cropCadre.transform : "translate(0px, 0px)";
                        
                        //attention si problème avec les tailles, c'est ici quand on set en jquery la taille
                        //etre attentif aux relicats !
                        //console.log(tempWidth)
                        //console.log(tempHeight)
                        //la taille de l'ancien se définit comme suit :
                        // - si il y avait déjà
                        setOnOverlap({
                            element: element, id: element.id,
                            back: { src: element.src, width: tempWidth, height: tempHeight, transform: tempTransform },
                            new: { src: sourceImage, text: item.text, sizePX: sizePX, sizePourcent: sizePourcent }
                        });

                        //on stocke les nouvelles et on applique comme c'est le cas
                        //on change la src du crop temporairement en jquery pour que ça visible
                        //$("#img-" + element.id).attr('src', 'http://localhost:3000/studio' + sourceImage);
                        $("#img-" + element.id).attr('src', val.text === 'upload' ? sourceImage : process.env.REACT_APP_PUBLIC_URL + sourceImage);
                        if (sizePX.width != null) $("#img-" + element.id).css('width', sizePourcent.width);
                        if (sizePX.height != null) $("#img-" + element.id).css('height', sizePourcent.height);
                        //on choisit de ne pas hériter du transform de l'image précédemment incluse, on set à 0
                        $("#img-" + element.id).css('transform', "translate(0px, 0px)");
                    }

                }
                //si onOverlap id vaut celui-ci mais qu'on est plus dans intersection => on libère onOverlap
                //else if (onOverlap.id == element.id && !haveIntersection(document.querySelector("#" + element.id)?.getBoundingClientRect(), targetRect)) {
                else if (onOverlap.id == element.id && !isMouseInside(document.querySelector("#" + element.id)?.getBoundingClientRect(), xy)) {
                    //si on passe la, c'est qu'il y a avait intersection dans le déplacement en cours, mais que l'on est sorti
                    //raz de onOverlap
                    //$("#img-" + element.id).attr('src', 'http://localhost:3000/studio' + onOverlap.back.src);
                    $("#img-" + element.id).attr('src', startsWithHttps(onOverlap.back.src) ? onOverlap.back.src : process.env.REACT_APP_PUBLIC_URL + onOverlap.back.src);
                    if (onOverlap.back.width != null) $("#img-" + element.id).css('width', onOverlap.back.width);
                    if (onOverlap.back.height != null) $("#img-" + element.id).css('height', onOverlap.back.height);
                    if (onOverlap.back.transform != null) $("#img-" + element.id).css('transform', onOverlap.back.transform);

                    //on ajoute une bordure sur cadre element

                    setOnOverlap({
                        id: null, element: null,
                        back: { src: null, width: null, height: null },
                        new: { src: null, text: null, sizePX: { width: null, height: null }, sizePourcent: { width: null, height: null } }
                    });

                }
            }

        });
    }

    function startsWithHttps(str: any) {
        return typeof str === "string" && str.startsWith("https://");
    }

    function getClientCoords(event:any) {
        // Touch events (mobile)
        if (event.touches && event.touches.length > 0) {
            return {
                x: event.touches[0].clientX,
                y: event.touches[0].clientY
            };
        }

        if (event.changedTouches && event.changedTouches.length > 0) {
            return {
                x: event.changedTouches[0].clientX,
                y: event.changedTouches[0].clientY
            };
        }

        // Mouse / Pointer events (desktop)
        return {
            x: event.clientX,
            y: event.clientY
        };
    }

    function onDragElement2(e: any, position: any) {
        //le param scale permet gérer la vitesse du drag, mais pose des problèmes de position
        //le fait de le remettre à 1 à la fin du drag resoud le pb
        var item = objItems.find(item => item.id === selectedItem!.id);

        handleCloneAndCornerPosition(item, { x: position.lastX, y: position.lastY }, position.node.offsetWidth, position.node.offsetHeight, false, zoomValue);

        //on peut mettre dans cadre-element, seulement une image, et qui n'est pas cropée
        if (item.type == 'image-element' && item.crop == null) {
            //ici, on passe l'item drag et sa position
            //handleOverlap(item, { x: position.lastX, y: position.lastY });
            //ici, on passe la position de la souri
            handleOverlap(item, getClientCoords(e));

            
        }

        setZoom(zoomValue)
    }

    function onDragElement(e: any, position: any) {
        const item = objItems.find(item => item.id === position.node.id);
        //item.x = position.x;
        //item.y = position.y;


        //setPositionT({ x: position.x*10, y: position.y *10})



        var isFixed = false;

        objItems.forEach((element) => {
            if (Math.abs(position.lastX - element.x) < 10 && element.id != item.id) {

                $("#guide-line")[0].setAttribute("x1", position.lastX)
                $("#guide-line")[0].setAttribute("y1", position.lastY)
                $("#guide-line")[0].setAttribute("x2", element.x)
                $("#guide-line")[0].setAttribute("y2", element.y)
                //console.log(rnd)
                //e.preventDefault();
                //e.nativeEvent.stopImmediatePropagation();

                setPositionT({ x: element.x, y: position.lastY })

                isFixed = true;

                //e.stopPropagation();
                // position.lastX = element.x
                /*if(rndRef.current != null) {
                    rndRef.current.updatePosition({ x: 0, y: 0 });
                    console.log(position)
                }*/

                // item.x = element.x

            }
            else if (position.lastY == element.y) { console.log("croisement") }
        });

        if (!isFixed) {
            setPositionT({ x: position.lastX, y: position.lastY })
        }

    }

    function onSizeElement(e: any, ref: any, delta: any, position: any) {
        //le param scale permet gérer la vitesse du drag, mais pose des problèmes de position
        //le fait de le remettre à 1 à la fin du drag resoud le pb

        //move spanClone into an above div (1er plan)
        $("#clone-" + selectedItem!.id).css({ top: position.y, left: position.x, width: ref.offsetWidth, height: ref.offsetHeight, position: 'absolute' });
        $("#clone-" + selectedItem!.id).find("div[class^='corner-resize-']").hide();
        $("#movecard-" + selectedItem.id).hide();

        //gestion des cadre-element
        const item = objItems.find(item => item.id === ref.id);

        if (item.type == 'cadre-element') {
            updateTransformCropCadreElement(item, ref.offsetWidth, ref.offsetHeight, false)
        }


        //CropImageCard update size position et position
        //si crop, la taille n'est plus gérer en pourcentage mais en pixel
        if (item.type == 'image-element') {
            if (item.crop && item.crop.isCrop) {

                //quand on retaille, on met à jour la full image, ici en dynamqiue, on doit mettre à jour en CSS la taille et la position
                let radioAgrandissement = ref.offsetHeight / item.height;

                var nWidth = getIntSize(item.crop.fullImage.width) * radioAgrandissement;
                var nHeight = getIntSize(item.crop.fullImage.height) * radioAgrandissement;

                //Permet de mettre à jour la taille de l'image element en direct
                //parce que l'image garde la grande taille, et c'est Rnd qui est plus petit avec le crop
                $("#" + item.id + ".image-element > img").css("width", nWidth);
                $("#" + item.id + ".image-element > img").css("height", nHeight);
                $("#" + val.id + ".image-element > img").css("left", -getIntSize(item.crop.cropPart.x) * radioAgrandissement + "px");
                $("#" + val.id + ".image-element > img").css("top", -getIntSize(item.crop.cropPart.y) * radioAgrandissement + "px");

            }
        }
    }

    function updateTransformCropCadreElement(item: any, newWidth: any, newHeight: any, isStop: boolean) {
        if (item.type == "cadre-element") {
            //si le CropCadreImageCard n'a pas été translate à l'intérieur, on évite les calculs (calculs par 0 vaut 0)
            if ((item.cropCadre.translate != null || !isNaN(item.cropCadre.translate.x)) && !(item.cropCadre.translate.x == 0 && item.cropCadre.translate.y == 0)) {

                let elemW = item.width; let elemH = item.height;

                //certains element width ou height attaché un a item, sont de type string, cela évite les calculs entre int*string = NaN
                if (typeof elemW === 'string' && elemW.includes("px")) elemW = parseInt(elemW.replace("px", ""))
                if (typeof elemH === 'string' && elemH.includes("px")) elemH = parseInt(elemH.replace("px", ""))

                let pourcentageResizeWidth = newWidth / elemW;
                let pourcentageResizeHeight = newHeight / elemH;

                let nX = parseFloat((item.cropCadre.translate.x * pourcentageResizeWidth).toFixed(3));
                let nY = parseFloat((item.cropCadre.translate.y * pourcentageResizeHeight).toFixed(3))

                let newTranform = { x: nX, y: nY }
                let newTransformTranslate = 'translate(' + newTranform.x + 'px, ' + newTranform.y + 'px)';

                //set save data only at end resize
                if (isStop) {
                    item.cropCadre.transform = newTransformTranslate;
                    item.cropCadre.translate = newTranform;
                }

                //set css
                $("#img-" + selectedItem.id).css({ transform: newTransformTranslate });
            }
        }
    }

    function updateSizeElement(ref: any, position: any) {
        const item = objItems.find(item => item.id === ref.id);

        handleCloneAndCornerPosition(item, position, ref.offsetWidth, ref.offsetHeight, true, zoomValue);

        var backPosition = { x: item.x, y: item.y, width: item.width, height: item.height, zoomValue, crop: cloneCrop(item.crop), cropCadre: cloneCropCadre(item.cropCadre) }

        //A faire avant le set de la nouvelle taille
        updateTransformCropCadreElement(item, ref.offsetWidth, ref.offsetHeight, true);

        item['width'] = ref.offsetWidth;
        item['height'] = ref.offsetHeight;

        item.x = position.x;
        item.y = position.y;


        //handle cropCadre data if not null, should be handle cause element is resize
        if (item.type == "cadre-element") {
            //if sizePX.height is null, that means any crop was already did
            if (item.cropCadre.sizePX.height != null) {
                //la taille de l'image derrière vaut la taile * le facteur d'agrandissement (item.cropCadre.sizePourcent)
                item.cropCadre.sizePX.width = ref.offsetWidth * parseFloat(item.cropCadre.sizePourcent.width) / 100;
                item.cropCadre.sizePX.height = ref.offsetHeight * parseFloat(item.cropCadre.sizePourcent.height) / 100;
            }
        }

        //fin de resize, on met à jour le crop si il y a
        if (item.type == 'image-element') {
            if (item.crop && item.crop.isCrop) {

                //quand on retaille, on met à jour la full image, ici en dynamqiue, on doit mettre à jour en CSS la taille et la position
                //voilà pourquoi on stocke une copie de la taille de l'image avant changement dans crop.cropPart
                let radioAgrandissement = ref.offsetHeight / item.crop.cropPart.height;

                var nWidth = getIntSize(item.crop.fullImage.width) * radioAgrandissement;
                var nHeight = getIntSize(item.crop.fullImage.height) * radioAgrandissement;

                //on met à jour la taille et la position de fullImage, ainsi que le delta x y sur cropPart
                item.crop.fullImage.width = nWidth;
                item.crop.fullImage.height = nHeight;
                item.crop.fullImage.x = position.x - getIntSize(item.crop.cropPart.x) * radioAgrandissement;
                item.crop.fullImage.y = position.y - getIntSize(item.crop.cropPart.y) * radioAgrandissement;

                item.crop.cropPart.x = item.crop.cropPart.x * radioAgrandissement;
                item.crop.cropPart.y = item.crop.cropPart.y * radioAgrandissement;
                item.crop.cropPart.width = ref.offsetWidth;
                item.crop.cropPart.height = ref.offsetHeight;

            }
        }

        //handle history, with all action, size, crop if 
        const action = createSizeElementAction(
            item,
            { addItem },
            backPosition,
            { x: position.x, y: position.y, width: ref.offsetWidth, height: ref.offsetHeight, zoomValue, crop: cloneCrop(item.crop), cropCadre: cloneCropCadre(item.cropCadre) }
        );

        history.add(action);

    }

    function cloneCrop(crop: any) {
        if (crop == null) return null;

        return {
            cropPart: { ...crop.cropPart },
            fullImage: { ...crop.fullImage },
            isCrop: crop.isCrop
        };

    }

    function cloneCropCadre(data: any) {
        if (data == null) return null;

        return {
            sizePX: {
                width: data.sizePX?.width,
                height: data.sizePX?.height
            },

            sizePourcent: {
                width: data.sizePourcent?.width,
                height: data.sizePourcent?.height
            },

            transform: data.transform,

            translate: {
                x: data.translate?.x,
                y: data.translate?.y
            },

            isPushImg: data.isPushImg
        };
    }

    function goEditText(e: any) {
        setEditText(true)
    }

    const handleTextChange = (e: any) => {
        const item = objItems.find(item => item.id === selectedItem.id);
        item.text = e.target.value;

        //maj border active
        let cloneDiv = $("#clone-" + selectedItem!.id);
        let article = $('#' + selectedItem.id)!.find("article");

        var articleW = article.width() as any;
        var articleH = article.height() as any;

        //cloneDiv.css({ top: item.y, left: item.x, width: articleW, height: articleH, position: 'absolute' });
        //replace and size corner and move card and stylo card      
        handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, zoomValue);

    }

    //The resizeHandleClasses property is used to set the className of one or more resize handles.
    //a remettre en place
    const rhC: HandleClasses = {
        //bottom: "corner-resize",
        bottomLeft: "corner-resize-bottomLeft",
        bottomRight: "corner-resize-c",
        //left: "corner-resize",
        //right: "corner-resize",
        //top: "corner-resize",
        topLeft: "corner-resize-c",
        topRight: "corner-resize-c",
    }

    const cssProp: React.CSSProperties = {
        position: 'absolute',
        borderRadius: '50%',
        backgroundColor: '#fff',
        boxShadow: '0 0 4px 1px rgba(57, 76, 96, .15), 0 0 0 1px rgba(43, 59, 74, .3)',
        zIndex: 999
    }

    const cssPropLine: React.CSSProperties = {
        backgroundColor: '#8b3dff',
        zIndex: 999
    }

    //const epaisseurBordure = 6;
    //           const epaisseurBordureTopBottom = epaisseurBordure / 2;

    const cornerStyle: HandleStyles = {
        bottom: { ...cssPropLine, height: epaisseurBordure, bottom: -epaisseurBordureTopBottom },
        bottomLeft: { ...cssProp, left: -sizeCornerResizeAbsolute, bottom: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
        bottomRight: { ...cssProp, right: -sizeCornerResizeAbsolute, bottom: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
        left: { ...cssPropLine, width: epaisseurBordure, left: -epaisseurBordureTopBottom },
        right: { ...cssPropLine, width: epaisseurBordure, right: -epaisseurBordureTopBottom },
        top: { ...cssPropLine, height: epaisseurBordure, top: -epaisseurBordureTopBottom },
        topLeft: { ...cssProp, left: -sizeCornerResizeAbsolute, top: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
        topRight: { ...cssProp, right: -sizeCornerResizeAbsolute, top: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
    }

    //gestion du z-index grâce à l'ordre (on commence à 1 pour laisser la map à 0 potentiellement)
    /* 
    * resizable => only if image-element
    */
    return (
        <Rnd
            id={val.id}
            //problème avec le clonage pour sélectionner l'élément, si zindex = 0?
            style={{ zIndex: index + 1, touchAction: selectedItem != null ? 'none' : 'auto' }}
            resizeHandleStyles={cornerStyle}
            resizeHandleClasses={rhC}
            ref={rndRef}
            /**/ default={{
                //x: val.x * 1 * 0.6,
                //y: val.y * 1 * 0.6,
                x: /*navigator.userAgent.indexOf("Firefox") !== -1 ? val.x *  zoomValue :*/ val.x,
                y: /*navigator.userAgent.indexOf("Firefox") !== -1 ? val.y *  zoomValue :*/ val.y,
                width: val.width != null ? val.width : 'auto',
                height: val.height != null ? val.height : 'auto',
            }}
            onDragStop={(e, d) => { /**/updatePositionElement(e, d) }}
            onDrag={(e, d) => { onDragElement2(e, d) }}
            onResizeStop={(e, direction, ref, delta, position) => {
                updateSizeElement(ref, position);
            }}
            onResize={(e, direction, ref, delta, position) => {
                onSizeElement(e, ref, delta, position);
            }}
            lockAspectRatio={val.type === 'image-element' || val.type === 'cadre-element' ? true : false}
            onClick={selectElement}
            //cancel="cancel"
            enableResizing={/**/(val.type === 'image-element' || val.type === 'shape-element' || val.type === 'cadre-element' || val.type === 'crop-cadre-element' || val.type === 'elevation-element') /**/ && !selectedItemIsLock && isSelectedItem ?
                { top: true, right: true, bottom: true, left: true, topRight: true, bottomRight: true, bottomLeft: true, topLeft: true } :
                { top: false, right: false, bottom: false, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false }}
            disableDragging={selectedItemIsLock || editText ? true : false || !isSelectedItem}
            //disableDragging={true}
            scale={/*navigator.userAgent.indexOf("Firefox") !== -1 ? zoomValue : zoom*/ zoomValue}
        //scale={zoom}
        //position={positionT}
        //dragGrid={[1, 1]}
        >
            <div id={val.id}
                className={val.class + (val.type !== "text-element" && isSelectedItem && selectedItemIsLock ? ' item-lock' : '')}
                //onClick={selectElement}
                data-x={val['data-x']}
                data-y={val['data-y']}
                style={{
                    fontStyle: val.style["font-style"],
                    fontFamily: val.style["font-family"],
                    fontWeight: val.style["font-weight"],
                    fontSize: val.style["font-size"],
                    textAlign: val.style["text-align"],
                    textDecoration: val.style["text-decoration"],
                    color: val.style.color,
                    display: 'inline-block',
                    opacity: val.style["opacity"] + '%',
                    position: 'relative',
                    overflow: val.crop && val.crop.isCrop && "hidden",
                    transform: val.style.transform != null ? val.style.transform : '',
                    letterSpacing: val.style.letterSpace != null ? val.style.letterSpace : ''

                }}>

                {val.type === 'text-element' && !selectedItemIsLock &&
                    <div className="pencil-blue-cont" onClick={goEditText}>
                        <img className="pencil-blue" src={editText ? process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/pencil-blue.svg" : process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/pencil-no.svg"}></img>
                    </div>}

                {/*(val.type === 'image-element' || val.type === 'shape-element' || val.type === 'elevation-element') && !selectedItemIsLock && <div className="corner-resize" style={{ left: -sizeCornerResizeSizeVisible, top: -sizeCornerResizeSizeVisible }}></div>}
                {(val.type === 'image-element' || val.type === 'shape-element' || val.type === 'elevation-element') && !selectedItemIsLock && <div className="corner-resize" style={{ right: -sizeCornerResizeSizeVisible, top: -sizeCornerResizeSizeVisible }}></div>}
                {(val.type === 'image-element' || val.type === 'shape-element' || val.type === 'elevation-element') && !selectedItemIsLock && <div className="corner-resize" style={{ left: -sizeCornerResizeSizeVisible, bottom: -sizeCornerResizeSizeVisible }}></div>}
                {(val.type === 'image-element' || val.type === 'shape-element' || val.type === 'elevation-element') && !selectedItemIsLock && <div className="corner-resize" style={{ right: -sizeCornerResizeSizeVisible, bottom: -sizeCornerResizeSizeVisible }}></div>*/}

                {val.type === 'text-element' &&
                    <ContentEditable key={val.id}
                        html={val.text} // innerHTML of the editable div
                        disabled={!editText || selectedItemIsLock}       // use true to disable editing
                        onChange={handleTextChange} // handle innerHTML change
                        tagName='article' // Use a custom HTML tag (uses a div by default)
                        placeholder={"Tapez votre texte"}
                        className="text-element-content"
                        spellCheck="false"
                        style={{ whiteSpace: 'nowrap' }}
                    />
                }
                {val.type === 'image-element' && val.text != 'upload' &&
                    <img
                        style={{
                            //gestion du crop Image => on positionne fullImage
                            width: (val.crop && val.crop.isCrop) ? val.crop.fullImage.width : "",
                            height: val.crop && val.crop.isCrop ? val.crop.fullImage.height : "",
                            top: val.crop && val.crop.isCrop ? -val.crop.cropPart.y : "",
                            left: val.crop && val.crop.isCrop ? -val.crop.cropPart.x : "",
                            position: val.crop && val.crop.isCrop && "absolute",
                        }}

                        src={process.env.REACT_APP_PUBLIC_URL + val.src} />
                }
                {val.type === 'image-element' && val.text === 'upload' && !val.src.includes('.svg') &&
                    <img
                        style={{
                            //gestion du crop Image => on positionne fullImage
                            width: (val.crop && val.crop.isCrop) ? val.crop.fullImage.width : "",
                            height: val.crop && val.crop.isCrop ? val.crop.fullImage.height : "",
                            top: val.crop && val.crop.isCrop ? -val.crop.cropPart.y : "",
                            left: val.crop && val.crop.isCrop ? -val.crop.cropPart.x : "",
                            position: val.crop && val.crop.isCrop && "absolute",
                        }}
                        src={val.src} />
                }
                {val.type === 'image-element' && val.text === 'upload' && val.src.includes('.svg') &&
                    <ReactSVG
                        beforeInjection={(svg) => {
                            svg.setAttribute('style', 'width: 100%;height: 100%')
                        }}
                        src={val.src}
                    />
                }
                {val.type === 'shape-element' &&
                    <div style=
                        {{
                            backgroundColor: val.style.color,
                            borderWidth: val.style["border-width"] != null ? val.style["border-width"] : 0,
                            borderColor: val.style["border-color"] != null ? val.style["border-color"] : "",
                            borderRadius: val.style["border-radius"] != null ? val.style["border-radius"] : "0",
                            borderStyle: val.style["border-style"] != null ? val.style["border-style"] : "",
                        }} >

                    </div>

                }
                {val.type === 'cadre-element' &&
                    <div>
                        <div className="original-cadre-element" style=
                            {{
                                /*backgroundColor: val.style.color,
                                borderWidth: val.style["border-width"] != null ? val.style["border-width"] : 0,
                                borderColor: val.style["border-color"] != null ? val.style["border-color"] : "",
                                borderRadius: val.style["border-radius"] != null ? val.style["border-radius"] : "0",
                                borderStyle: val.style["border-style"] != null ? val.style["border-style"] : "",*/
                                //Oups clip-path doesn't work for html2canvas...
                                clipPath: val.style["clip-path"] != null ? val.style["clip-path"] : ""
                                //borderRadius : '50%'
                            }}>
                            <img
                                id={'img-' + val.id}
                                //src={val.text === 'upload' ? val.src : "http://localhost:3000/studio" + val.src}
                                src={val.text === 'upload' ? val.src : process.env.REACT_APP_PUBLIC_URL + val.src}
                                //
                                //prod => src={val.src}
                                style={{
                                    //size should be in pourcent to let cadre-element resize works (if size in px, it will be fixed)
                                    height: val.cropCadre.sizePourcent.height != null ? val.cropCadre.sizePourcent.height : "",
                                    width: val.cropCadre.sizePourcent.width != null ? val.cropCadre.sizePourcent.width : "",
                                    transform: val.cropCadre.transform != null ? val.cropCadre.transform : ""
                                }} />
                        </div>
                    </div>
                }

                {val.type === 'elevation-element' &&
                    <Line className="elevation-element" options={val.options} /*data={val.data}*/ /**/ data={elevationData} /*redraw={true}*/ ref={chartRefState} />
                }

            </div>
        </Rnd>
    );
}

function addCropCadreElementAction(item: any, backPosition: { x: any; y: any; width: any; height: any; zoomValue: any; }, arg2: { x: any; y: any; width: any; height: any; zoomValue: any; }) {
    throw new Error("Function not implemented.");
}
